// 로컬 CLI 데몬 주소 — 화면 코드는 여기서만 읽는다(포트를 코드에 박지 않는다).
// 값은 빌드 때 vue.config.js 가 VUE_APP_CLI_DAEMON_PORT 로 정한다:
//   운영 빌드(CI·deploy.yml) = 9876(사용자 PC 의 실제 데몬)
//   로컬 serve·로컬 빌드     = 0(데몬 없음 · 공용 시험 데몬에 몰래 붙지 않게). 붙이려면 포트를 명시(9877 시험 · 9876 운영)
// 데몬 없음이면 CLI_DAEMON_ENABLED=false — 부르는 곳은 요청을 보내지 않는다(cliDaemonUrl 은 던진다).
const port = Number(process.env.VUE_APP_CLI_DAEMON_PORT);

export const CLI_DAEMON_ENABLED = Number.isInteger(port) && port > 0;
if (!CLI_DAEMON_ENABLED) {
  console.error('[cliDaemon] CLI 데몬 없음 — 이 빌드는 VUE_APP_CLI_DAEMON_PORT 를 안 받았다(로컬 기본). 붙이려면 빌드 때 포트를 명시:', process.env.VUE_APP_CLI_DAEMON_PORT);
}

export const CLI_DAEMON_PORT = CLI_DAEMON_ENABLED ? port : 0;
export const CLI_DAEMON_ORIGIN = CLI_DAEMON_ENABLED ? `http://127.0.0.1:${port}` : '';
export const cliDaemonUrl = (path) => {
  if (!CLI_DAEMON_ENABLED) throw new Error('CLI 데몬이 없는 빌드예요(VUE_APP_CLI_DAEMON_PORT 미지정) — 요청 안 보냄: ' + path);
  return CLI_DAEMON_ORIGIN + path;
};
